// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
// import React from 'react'
import { LoginStorage, saveReturnUrl } from '@arredo/reactjs-ui'
import { useNavigate } from 'react-router-dom'
import loginService from '../../services/loginService'
import useAuthorize from '../../hooks/user/useAuthorize'
import { ClearUserToken } from '../../hooks/user/useUser'

const PrivateRoute = ({ children, permission }) => {
  const isAuthorized = useAuthorize()
  const navigate = useNavigate()

  // Add your own authentication on the below line.
  const token = LoginStorage.token()
  const login = async () => {
    // redirectUrl stays the bare origin to match the URI registered in Entra
    // ID, so park the requested route first and restore it after the login.
    saveReturnUrl()
    const loginUrl = await loginService.GetLogin(window.location.origin)
    ClearUserToken()
    window.location.replace(loginUrl)
  }

  const unauthorize = (permission) => {
    navigate(`/unauthorized/${permission}`)
  }

  if (!token) {
    login()
    return null // este return es solo para asegurarse de que no se renderice nada más mientras redirecciona
  }

  if (permission && !isAuthorized(permission)) {
    unauthorize(permission)
    return null
  }

  return children
}

export default PrivateRoute
